module.exports = __webpack_public_path__ + "static/img/zhou.8868036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhou.png
// module id = RmOp
// module chunks = 0